import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'
import Subtitle from '../../atoms/Subtitle'
import PlaneIcon from '../../atoms/PlaneIcon'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Description = styled(Subtitle)`
  margin-top: 19px;
`

const DescriptionBottom = styled(Subtitle)`
  margin-top: 23px;
`

const Email = styled(Text)`
  text-align: center;
`

const MagicLinkEmailSentTemplate = ({ email }) => (
  <Content>
    <PlaneIcon />
    <Description>Enviamos um e-mail para</Description>
    <Email fontWeight={600}>{email}</Email>
    <DescriptionBottom>
      Acesse seu e-mail e clique no botão para entrar na sua conta rapidamente.
    </DescriptionBottom>
  </Content>
)

MagicLinkEmailSentTemplate.propTypes = {
  email: PropTypes.string.isRequired,
}

export default MagicLinkEmailSentTemplate
